import { ActionTypes } from "../constants/index";

export default function tables(
	state = {
		isFetching: false,
	},
	action
) {
	switch (action.type) {
		case ActionTypes.FETCH_TABLES_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});
		case ActionTypes.FETCH_TABLES_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				tables: action.tables,
			});
		case ActionTypes.FETCH_TABLES_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Something wrong happened. Please come back later",
			});

		default:
			return state;
	}
}
